import * as React from 'react';

import { useToaster } from 'react-hot-toast';
import { ToastBar } from './toast-bar';
import { ToastPosition } from 'react-hot-toast';

interface ToasterProps {
  position?: ToastPosition;
  reverseOrder?: boolean;
  containerStyle?: any;
  toastOptions?: any;
}

export let Toaster: React.FC<ToasterProps> = ({
  reverseOrder,
  position = 'top-center',
  containerStyle,
  toastOptions
}) => {
  let { toasts, handlers } = useToaster(toastOptions);

  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 9999,
        ...containerStyle
      }}
      onMouseEnter={handlers.startPause}
      onMouseLeave={handlers.endPause}
    >
      {toasts.map(t => {
        return (
          <ToastBar
            key={t.id}
            onHeight={height => handlers.updateHeight(t.id, height)}
            toast={t}
            offset={handlers.calculateOffset(t.id, {
              reverseOrder
            })}
            position={position}
          />
        );
      })}
    </div>
  );
};
